module.exports = __webpack_public_path__ + "static/pattern-floral.d18aeb69.svg";